import React from "react";
// import Card from "react-bootstrap/Card";
import Card from "./Card/Card";
import { Link } from "react-router-dom";

function Collection() {
    return (
        <div className=" mt-5">
            <div class="container ">
                <div class="row p-0 m-0">
                <div class="col-md-4">
                    <Link to="/wear">
                        <Card
                          imgUrl2="./image/swiss.jpg"
                            img="./image/wear.jpg"
                            title="SWISS LAWN"
                        />
                        </Link>
                    </div>
                    <div class="col-md-4">
                    <Link to="/wear">
                        <Card
                          imgUrl2="./image/wear.jpg"
                            img="./image/swiss.jpg"
                            title="SWISS LAWN"
                        />
                        </Link>
                    </div>
                    <div class="col-md-4">
                    <Link to="/wear">
                        <Card
                          imgUrl2="./image/swiss.jpg"
                            img="./image/dupattas.jpg"
                            title="DUPATTAS"
                        />
                        </Link>
                    </div>

                </div>
                <div class="row m-0 p-0">
                    <div class="col-md-4">
                    <Link to="/wear">
                        <Card
                          imgUrl2="./image/swiss.jpg"
                            img="./image/chantele.jpg"
                            title="CHANTELLE"
                        />
                        </Link>
                    </div>
                    <div class="col-md-4">
                    <Link to="/wear">
                        <Card
                          imgUrl2="./image/swiss.jpg"
                            img="./image/bottoms.jpg"
                            title="BOTTOMS"
                        />
                        </Link>
                    </div>
                    <div class="col-md-4">
                    <Link to="/wear">
                        <Card
                          imgUrl2="./image/swiss.jpg"
                            img="./image/special.jpg"
                            title="SPECIAL PRICE"
                        />
                        </Link>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Collection;
